import React from 'react';

import { useFormContext } from 'react-hook-form';
import { Collapse, Grid } from '@mui/material';

import { FlightEventReport, ReportType, EventFormStatus } from '../../../core/api/clients';
import AttachmentList from '../../../components/AttachmentList';
import ControlledTextField from '../../../components/ControlledTextField';
import { useFlightEventReportData } from '../../../core/context/FlightEventReportDataContext';
import { useAuthorizedFormData } from '../../../core/context/AuthorizedFormDataContext';

function NarrativeStep({ visible, readOnly }: { visible: boolean, readOnly?: boolean }) {
  const { control } = useFormContext<FlightEventReport>();
  const { flightEventReport, allowedActions } = useFlightEventReportData();
  const authorizedFormData = useAuthorizedFormData();
  return (
    <Collapse in={visible}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ControlledTextField<FlightEventReport>
            control={control}
            name="narrative"
            TextFieldProps={{
              multiline: true,
              rows: 6,
            }}
            readOnly={readOnly}
            rules={{ required: true }}
            disableEditPopper={!allowedActions?.edit}
          />
        </Grid>
        <Grid item xs={12}>
          <AttachmentList
            reportType={ReportType.FlightEventReport}
            reportId={flightEventReport.id}
            allowedActions={allowedActions}
          />
        </Grid>
        {flightEventReport.status !== EventFormStatus.Draft && (authorizedFormData.isApprover || authorizedFormData.isAdministrator) && (
          <Grid item xs={12}>
            <ControlledTextField<FlightEventReport>
              control={control}
              name="approverComments"
              TextFieldProps={{
                multiline: true,
                rows: 6,
              }}
              readOnly={readOnly}
              rules={{ required: true }}
              disableEditPopper={!allowedActions?.edit}
            />
          </Grid>
        )}
      </Grid>
    </Collapse>
  );
}

export default NarrativeStep;
